import { VisibilityOutlined } from '@mui/icons-material';
import { Alert, Box } from '@mui/material';
import { useAuthContext } from 'src/context/AuthContextProvider';

import { useMonitorContext } from '../MonitorContextProvider';

export function GuestEnvironmentAlert() {
  const { auth } = useAuthContext();
  const { guestEnvironmentOwnerId } = useMonitorContext();

  if (!guestEnvironmentOwnerId) {
    return null;
  }

  const guestUserWalletEnvironment =
    auth.user?.guestUserWalletEnvironments?.find(
      (environment) => environment.owner.id === Number(guestEnvironmentOwnerId),
    );

  if (!guestUserWalletEnvironment) {
    return null;
  }

  return (
    <Box mb={1}>
      <Alert
        icon={<VisibilityOutlined />}
        severity="info"
        sx={{
          backgroundColor: 'rgba(33, 150, 243, 0.1)',
          border: '1px solid rgba(33, 150, 243, 0.3)',
          '& .MuiAlert-icon': {
            color: '#2196f3',
          },
          '& .MuiAlert-message': {
            color: '#1565c0',
            fontWeight: 500,
          },
        }}>
        As alterações feitas aqui afetam o ambiente de{' '}
        <strong>{guestUserWalletEnvironment?.owner.name}</strong>
      </Alert>
    </Box>
  );
}
